import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

// Defines the shape of the data our context will hold
interface ReloadConfigContextType {
	isReloadRequired: boolean; // The actual state value
	setReloadRequired: (required: boolean) => void; // Function to update the state
}

// This is the actual "container" for the state.
const ReloadConfigContext = createContext<ReloadConfigContextType | undefined>(
	undefined
);

// This component manages the state and provides it to all of its children.
export function ReloadConfigProvider({ children }: { children: ReactNode }) {
	// Initialize the state that will be shared globally
	const [isReloadRequired, setReloadRequired] = useState(false);

	return (
		// The Provider makes the 'value' available to any child component that asks for it
		<ReloadConfigContext.Provider value={{ isReloadRequired, setReloadRequired }}>
			{children}
		</ReloadConfigContext.Provider>
	);
}

// Instead of writing `useContext(ReloadConfigContext)` everywhere, they just call `useReloadConfig()`.
export function useReloadConfig() {
	const context = useContext(ReloadConfigContext);

	if (context === undefined) {
		throw new Error(
			"useReloadConfig must be used within a ReloadConfigProvider"
		);
	}

	return context;
}
